import React, { Component } from 'react';
import { Popup, Icon } from 'semantic-ui-react'
import _ from 'lodash'
const showMore = {
    position: 'absolute',
    right: "15px",
    bottom: "-5px",
    fontSize: "10px",
    color: "#ccc",
    textDecoration: "underline",
    cursor: "pointer",
}
export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            overflowActive: false,
            showMore: false
        };
        this.showMore = this.showMore.bind(this)
        this.showLess = this.showLess.bind(this)
    }
    isEllipsisActive(e) {
        return e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth;
    }

    componentDidMount() {
        this.setState({ overflowActive: this.isEllipsisActive(this.div) });
    }

    componentWillReceiveProps() {
        this.setState({ overflowActive: this.isEllipsisActive(this.div) });
    }

    showMore(e) {
        this.setState({ showMore: true })
        e.stopPropagation()
    }
    showLess(e) {
        this.setState({ showMore: false })
        e.stopPropagation()
    }

    render() {
        let checkLines = this.props.line === 1 ? "break-one-line" :
            this.props.line === 2 ? "break-two-line" :
                this.props.line === 3 ? "break-three-line" :
                    this.props.line === 4 ? "break-four-line" :
                        this.props.line === 5 ? "break-five-line" :
                            this.props.line === 6 ? "break-six-line" :
                                this.props.line === 7 ? "break-seven-line" : "break-one-line"

        let checkTextareaValue = this.props.name && this.props.name.length === 0 || this.props.name === '<p><br></p>' || this.props.name === ''

        let stripName = '';
        if (typeof (this.props.name) === 'string') {
            stripName = this.props.name.replace(/(<([^>]+)>)/gi, "")
        } else {
            stripName = this.props.name
        }

        return (
            <div
                ref={ref => (this.div = ref)}
                style={this.props.style}
                className={` ${this.props.className ? this.props.className : ""} ${this.state.showMore ? "" : checkLines}`}
            >
                {this.state.overflowActive ?
                    this.props.ReadMore ?
                        <div>
                            {this.props.htmlView ?
                                this.props.stripHtml ?
                                    stripName
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: this.props.name }} /> :
                                <span>
                                    {this.props.arrowIcon ?
                                        <Icon name="chevron right" />
                                        : null}
                                    {this.props.name}
                                </span>
                            }
                            {this.props.deprecated && <span className='clr-red'>(deprecated)</span>}

                            {/* {this.state.showMore ?
                                <p className="showMore" onClick={this.showLess} style={showMore}>Hide</p> :
                                <p className="showMore" onClick={this.showMore} style={showMore}>Read More</p>
                            } */}

                        </div> :
                        <Popup
                            mouseEnterDelay={400}
                            inverted
                            className="popupStyled"
                            trigger={<span>{this.props.arrowIcon ? <Icon name="chevron right" /> : null}{this.props.name}{this.props.deprecated && <span className='clr-red'>(deprecated)</span>}</span>}
                            content={this.props.name}
                            position={this.props.position ? this.props.position : "top left"}
                        >
                        </Popup> :
                    <span style={{ wordBreak: 'break-word' }} >
                        {this.props.htmlView ?
                            this.props.stripHtml ?
                                stripName
                                :
                                <div dangerouslySetInnerHTML={{ __html: this.props.name }} /> :
                            <span>{this.props.arrowIcon ? <Icon name="chevron right" /> : null}{this.props.name}</span>
                        }
                        {this.props.deprecated && <span className='clr-red'>(deprecated)</span>}
                    </span>
                }
            </div>
        );
    }
}
